@if (invoice?.orders_minimal && invoice!.orders_minimal!.length > 0) {
	<div i18n>
		This cost invoice is already assigned to order: {{ invoice?.orders_minimal?.[0]?.order_name }}
		{{
			invoice!.orders_minimal![0].order_container_number
				? '(' + invoice!.orders_minimal![0].order_container_number + ')'
				: ''
		}}
		do you want to unassigned it?
	</div>
	<div class="submit-row row__end row">
		<epic-button
			[text]="invoice?.is_group_invoice ? textUpdateInvoice : textUnassign"
			(onClick)="unassignInvoice()" />
	</div>
} @else {
	<div
		center
		class="row form align__center">
		<epic-form-field
			[text]="textChooseOrder"
			class="form_field form__element-12">
			<epic-autocomplete
				(searchChange)="handleOrderSearchValueChanges($event)"
				[control]="form.controls.order"
				[customSelectedValues]="true"
				class="cost-invoice-order-content"
				(modelChange)="onOrderSelect()">
				<div
					class="epic-select__custom-values"
					selected-values>
					<span
						*ngIf="form.controls.order?.value?.number"
						class="epic-select__value-round"
						>{{ form.controls.order?.value?.number }}</span
					>
				</div>
				@for (order of orders; track order.id) {
					<epic-option
						[value]="order"
						[selected]="false"
						class="epic_select__option">
						<span>{{ order.number }} </span>
						@if (!order?.conveyance_type?.is_container_number_required) {
							@if (order?.package_count && order?.container_weight) {
								({{ order?.package_count }}<span i18n>PC</span> / {{ order?.container_weight }}<span i18n>kg</span>)
							} @else if (order?.package_count) {
								({{ order?.package_count }}<span i18n>PC</span>)
							} @else if (order?.container_weight) {
								({{ order?.container_weight }}<span i18n>kg</span>)
							} @else {
								({{ order?.container_number }})
							}
						} @else {
							{{ order?.container_number }}
						}
					</epic-option>
				}
			</epic-autocomplete>
		</epic-form-field>
		<div
			center
			[class]="
				form.controls.order?.value?.id
					? 'form_field form__element-12 align__center'
					: 'form_field no-active form__element-12 row align__center'
			">
			<epic-form-field
				[text]="textChooseTask"
				class="form_field row form__element-12">
				<epic-autocomplete
					(searchChange)="handleOrderTaskSearchValueChanges($event, form.controls.order?.value?.id)"
					[control]="form.controls.task"
					[customSelectedValues]="true"
					class="cost-invoice-order-content">
					<div
						class="epic-select__custom-values"
						selected-values>
						<span
							*ngIf="form.controls.task?.value?.name"
							class="epic-select__value-round"
							>{{ form.controls.task?.value?.name }}</span
						>
					</div>
					@for (task of this.tasks; track task.id) {
						<epic-option
							[value]="task"
							[selected]="false"
							class="epic_select__option">
							{{ task.name }}
						</epic-option>
					}
				</epic-autocomplete>
			</epic-form-field>
		</div>
	</div>
	<div class="submit-row row__end row">
		<epic-button
			[text]="invoice?.is_group_invoice ? textUpdateInvoice : textAssign"
			(onClick)="submit()" />
	</div>
}
